export const billersListSelector = (state) => state.biller.billersList;
